(function () {
'use strict';
var cfg = document.getElementById('oaf-table-leaf-validation-config');
if (!cfg) return;
var config = JSON.parse(cfg.textContent);
var profiles = config.profiles || {};
var defaultProfile = {fields:{width:'Width',leaves:'Extension Leaves',skirts:'Leaf Skirts'}};
function rhTable(item) {
  return /rh\s*yoder|woodside/i.test(String(item.vendor || '')) &&
    /table/i.test(String(item.product_title || item.title || ''));
}
var butterflyProfile = {fields:{leaves:'Extension Leaves'}, butterflyOnly:true};
function anyTable(item) {
  return /table/i.test(String(item.product_title || item.title || ''));
}
var profile = profiles[config.productHandle] || (rhTable(config) ? defaultProfile : (anyTable(config) ? butterflyProfile : null));
config.product = Boolean(profile);
config.hasTheo = (config.cartProducts || []).some(function (item) { return Boolean(profileFor(item)); });
if (!config.product && !config.hasTheo) return;
function profileFor(item) {
  for (var handle in profiles) {
    if (item.handle === handle || item.product_title === profiles[handle].title ||
        String(item.url || '').split('?')[0].split('#')[0] === '/products/' + handle) return profiles[handle];
  }
  var known = (config.cartProducts || []).find(function (product) {
    return product.handle === item.handle || product.product_title === item.product_title ||
      String(item.url || '').split('?')[0].split('#')[0] === '/products/' + product.handle;
  });
  if (rhTable(known || item)) return defaultProfile;
  return anyTable(known || item) ? butterflyProfile : null;
}
var words = ['solid top','one','two','three','four','five','six','seven','eight','nine'];
function leafCount(text) {
  var clean = String(text || '').trim().toLowerCase();
  if (/^solid[\s-]*top\b/.test(clean)) return 0;
  var number = clean.match(/^(\d+)\s*[-–]?\s*(?:leaf\b|leaves\b|$)/);
  if (number) return Number(number[1]);
  var word = clean.match(/^(one|two|three|four|five|six|seven|eight|nine)\b/);
  return word ? words.indexOf(word[1]) : null;
}
function message(count, total) {
  return 'You selected ' + count + ' extension leaves, but assigned ' + total +
    '. Make the combined No Skirt, Skirt, and Magnetic Skirt quantities equal ' + count + '.';
}
function show(text, target) {
  var box = document.getElementById('oaf-table-leaf-validation-error');
  if (!box) {
    box = document.createElement('div');
    box.id = 'oaf-table-leaf-validation-error';
    box.setAttribute('role', 'alert');
    box.tabIndex = -1;
    box.style.cssText = 'padding:14px;margin:14px 0;border:1px solid #b42318;background:#fff4f2;color:#8c1d18;font-size:16px;line-height:1.5';
    var anchor = document.getElementById('oaf-dpo-inline-slot') ||
      document.querySelector('.cart__footer, #main-cart-footer, main');
    if (anchor) anchor.prepend(box);
    else document.body.appendChild(box);
  }
  box.textContent = text;
  box.focus();
  box.scrollIntoView({block:'center'});
  if (target) {
    var details = target.querySelector('details');
    if (details) details.open = true;
  }
}
function normalizedLabel(text) {
  return String(text || '').replace(/\*/g, '').replace(/\s+/g, ' ').trim().toLowerCase();
}
function aliases(title) {
  var key = normalizedLabel(title);
  return /^(extension leaves|leaves)$/.test(key) ? ['extension leaves', 'leaves'] : [key];
}
function field(root, title) {
  var names = aliases(title);
  return Array.from(root.querySelectorAll('.field')).find(function (node) {
    if (node.classList.contains('choice')) return false;
    var label = node.querySelector(':scope > label');
    return label && names.indexOf(normalizedLabel(label.textContent)) !== -1;
  });
}
function property(props, title) {
  var names = aliases(title);
  var key = Object.keys(props).find(function (name) {
    return names.indexOf(normalizedLabel(name)) !== -1;
  });
  return key === undefined ? undefined : props[key];
}
function butterflyField(root) {
  return Array.from(root.querySelectorAll('.field')).find(function (node) {
    if (node.classList.contains('choice')) return false;
    var label = node.querySelector(':scope > label');
    return label && /butterfly/i.test(label.textContent);
  });
}
function butterflyChosen(text) {
  var clean = String(text || '').replace(/\s+/g, ' ').trim().toLowerCase();
  return Boolean(clean) && !/^(none|no\b|select)/.test(clean);
}
function butterflyProperty(props) {
  var key = Object.keys(props).find(function (name) { return /butterfly/i.test(name); });
  return key === undefined ? '' : props[key];
}
var butterflyMessage = 'Extension leaves and butterfly leaves cannot be ordered together. Choose Solid Top to add a butterfly leaf, or remove the butterfly leaf to use extension leaves.';
function productButterflyError(root, count) {
  if (!count) return '';
  var field = butterflyField(root);
  if (!field || field.classList.contains('ihidden') || field.closest('.ihidden')) return '';
  var picked = Array.from(field.querySelectorAll('input:checked')).filter(function (input) { return !input.disabled; }).some(function (input) {
    var label = field.querySelector('label[for="' + CSS.escape(input.id) + '"]');
    return butterflyChosen(label ? label.textContent : input.value);
  });
  var select = field.querySelector('select');
  if (!picked && select && select.value) picked = butterflyChosen(select.options[select.selectedIndex].textContent);
  return picked ? butterflyMessage : '';
}
function productError() {
  var root = document.getElementById('itoris_dynamicproductoptions');
  if (!root) return profile.butterflyOnly ? '' : 'Please wait for the table options to finish loading.';
  var leaves = field(root, profile.fields.leaves);
  if (!leaves) return '';
  if (profile.butterflyOnly) {
    var bSelect = leaves.querySelector('select');
    var bSelected = leaves.querySelector('input:checked');
    var bLabel = bSelected && leaves.querySelector('label[for="' + CSS.escape(bSelected.id) + '"]');
    var bCount = leafCount(bSelect && bSelect.value ? bSelect.options[bSelect.selectedIndex].textContent : bLabel && bLabel.textContent);
    return bCount ? productButterflyError(root, bCount) : '';
  }
  var select = leaves.querySelector('select');
  var selected = leaves.querySelector('input:checked');
  if (!selected && (!select || !select.value)) return 'Please select your extension leaves.';
  var label = selected && leaves.querySelector('label[for="' + CSS.escape(selected.id) + '"]');
  var count = leafCount(select ? select.options[select.selectedIndex].textContent : label && label.textContent);
  if (count === null || (profile.maxLeaves != null && count > profile.maxLeaves)) return 'Please select a valid extension leaf count.';
  if (!count) return '';
  var butterfly = productButterflyError(root, count);
  if (butterfly) return butterfly;
  var skirts = field(root, profile.fields.skirts);
  if (!skirts) return '';
  var total = 0, bad = false;
  skirts.querySelectorAll('input[type="checkbox"]:checked').forEach(function (input) {
    if (input.disabled) return;
    var qty = input.closest('.choice').querySelector('input.option-qty, input[name^="options_qty["]');
    var n = qty ? Number(qty.value) : NaN;
    if (!Number.isInteger(n) || n < 1) bad = true;
    else total += n;
  });
  if (bad) return 'Enter a whole-number quantity of at least 1 for each selected leaf treatment.';
  return total === count ? '' : message(count, total);
}
function cartError(items) {
  for (var item of items) {
    var profile = profileFor(item);
    if (!profile) continue;
    var props = item.properties || {};
    if (profile.butterflyOnly) {
      if (leafCount(property(props, profile.fields.leaves)) && butterflyChosen(butterflyProperty(props)))
        return 'Table options: ' + butterflyMessage;
      continue;
    }
    if (property(props, profile.fields.leaves) === undefined && !profiles[item.handle]) continue;
    var count = leafCount(property(props, profile.fields.leaves));
    if (count === null || (profile.maxLeaves != null && count > profile.maxLeaves)) return 'Please configure the table extension leaves before checkout.';
    if (!count) continue;
    if (butterflyChosen(butterflyProperty(props))) return 'Table options: ' + butterflyMessage;
    if (property(props, profile.fields.skirts) === undefined) continue;
    var treatments = String(property(props, profile.fields.skirts) || '');
    var regex = /(\d+(?:\.\d+)?)\s*[x×]\s*(?:No Skirts?|Magnetic Skirts?|Skirts?)\b/gi;
    var total = 0, match, found = false, bad = false;
    while ((match = regex.exec(treatments))) {
      var n = Number(match[1]);
      found = true;
      if (!Number.isInteger(n) || n < 1) bad = true;
      total += n;
    }
    if (!found || bad || total !== count)
      return 'Table options: ' + (found && !bad ? message(count, total) :
        'Please configure the leaf treatment quantities before checkout.');
  }
  return '';
}
function stop(event, error) {
  event.preventDefault();
  event.stopImmediatePropagation();
  show(error, document.getElementById('itoris_dynamicproductoptions'));
}
var checkoutBusy = false, replay = false;
async function checkout(event, control) {
  if (replay) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  if (checkoutBusy) return;
  checkoutBusy = true;
  try {
    var response = await fetch(config.cartUrl, {credentials:'same-origin',cache:'no-store'});
    if (!response.ok) throw new Error('cart');
    var cart = await response.json();
    var error = cartError(cart.items || []);
    if (error) { show(error); return; }
    replay = true;
    try {
      if (control) control.click();
      else if (event.target.requestSubmit) event.target.requestSubmit(event.submitter || undefined);
    } finally { replay = false; }
  } catch (err) {
    show('We could not verify the table options. Please reload the cart and try again.');
  } finally { checkoutBusy = false; }
}
window.addEventListener('click', function (event) {
  var target = event.target instanceof Element ? event.target : null;
  if (!target) return;
  if (config.product) {
    var purchase = target.closest('[type="submit"], [dpo_add2cart], .shopify-payment-button, .buy-now-container');
    if (!purchase && /buy it now/i.test(target.textContent || '') && target.closest('button,a')) purchase = target.closest('button,a');
    if (purchase && (purchase.closest('product-form') || purchase.closest('#MainContent'))) {
      var error = productError();
      if (error) stop(event, error);
    }
  }
  var control = target.closest('button[name="checkout"], input[name="checkout"], a[href*="/checkout"], #checkout');
  if (control && config.hasTheo && !replay) checkout(event, control);
}, true);
window.addEventListener('submit', function (event) {
  if (config.product && event.target.matches('form[action*="/cart/add"]')) {
    var error = productError();
    if (error) { stop(event, error); return; }
  }
  if (config.cart && config.hasTheo && event.target.matches('form[action*="/cart"]') &&
      (!event.submitter || event.submitter.name === 'checkout') && !replay) checkout(event, null);
}, true);
document.addEventListener('change', function () {
  var box = document.getElementById('oaf-table-leaf-validation-error');
  if (config.product && box && !productError()) box.remove();
});
function updateStorage() {
  if (!profile || !profile.storageByWidth) return;
  var root = document.getElementById('itoris_dynamicproductoptions');
  if (!root) return;
  var width = field(root, profile.fields.width);
  var selected = width && width.querySelector('input:checked');
  var label = selected && width.querySelector('label[for="' + CSS.escape(selected.id) + '"]');
  var match = label && label.textContent.match(/^\s*(\d+)/);
  var storage = match && profile.storageByWidth[match[1]];
  var box = document.getElementById('oaf-table-leaf-storage');
  var anchor = document.querySelector('.oaf-magnetic-leaf-info');
  if (!anchor) return;
  if (!box) {
    box = document.createElement('p');
    box.id = 'oaf-table-leaf-storage';
    box.className = 'oaf-seating-guide__note';
    anchor.appendChild(box);
  }
  var text = storage ? 'Manufacturer self-storage for ' + match[1] + '″ width: up to ' +
    storage.skirted + ' skirted and ' + storage.unskirted +
    ' unskirted leaves. This is storage capacity, not the maximum number of extension leaves.' :
    'Select a table width to see the manufacturer’s leaf self-storage capacity.';
  if (box.textContent !== text) box.textContent = text;
}
document.addEventListener('input', updateStorage);
document.addEventListener('change', updateStorage);
updateStorage();
var storageChecks = 0;
var storageTimer = setInterval(function () {
  updateStorage();
  if (++storageChecks >= 30) clearInterval(storageTimer);
}, 500);


var skirtStyleCss = [
  '#MainContent #itoris_dynamicproductoptions .oaf-leaf-skirt-options .oaf-leaf-skirt-choice > label{flex-wrap:nowrap!important;align-items:center!important;flex-direction:row!important;justify-content:space-between!important;text-align:left!important;gap:12px!important}',
  '#MainContent #itoris_dynamicproductoptions .oaf-leaf-skirt-options .oaf-leaf-skirt-choice > label .price-notice{margin-left:auto;white-space:nowrap;font-size:15px!important;color:#5b5142}',
  '#MainContent #itoris_dynamicproductoptions .oaf-leaf-skirt-options .oaf-leaf-skirt-choice{margin:0 0 10px!important;cursor:pointer}',
  '#MainContent #itoris_dynamicproductoptions .oaf-leaf-skirt-options .oaf-leaf-skirt-choice:not(.oaf-leaf-skirt-selected) .option-qty-wrapper{display:none!important}',
  '#MainContent #itoris_dynamicproductoptions .oaf-leaf-skirt-options .oaf-leaf-skirt-qty{margin:0!important}',
  '#oaf-leaf-skirt-total{margin:0 0 12px;padding:10px 12px;border-radius:6px;font-size:15px;line-height:1.5;background:#fff4e5;color:#7a4a00;border:1px solid #f0d3a4}',
  '#oaf-leaf-skirt-total.is-complete{background:#f1f6ec;color:#3d5a26;border-color:#c5d8b4}'
].join('\n');
function skirtTally(root) {
  var leaves = field(root, profile.fields.leaves);
  var skirts = field(root, profile.fields.skirts);
  if (!leaves || !skirts) return null;
  var selected = leaves.querySelector('input:checked');
  var select = leaves.querySelector('select');
  var label = selected && leaves.querySelector('label[for="' + CSS.escape(selected.id) + '"]');
  var count = leafCount(select ? select.options[select.selectedIndex].textContent : label && label.textContent);
  var total = 0;
  skirts.querySelectorAll('input[type="checkbox"]:checked').forEach(function (input) {
    if (input.disabled) return;
    var qty = input.closest('.choice') && input.closest('.choice').querySelector('input.option-qty, input[name^="options_qty["]');
    var n = qty ? Number(qty.value) : 0;
    if (Number.isInteger(n) && n > 0) total += n;
  });
  return {count: count, total: total};
}
function updateSkirtTally(root, skirts) {
  var tally = skirtTally(root);
  var box = document.getElementById('oaf-leaf-skirt-total');
  if (!tally || !tally.count || skirts.classList.contains('ihidden')) { if (box) box.remove(); return; }
  if (!box) {
    box = document.createElement('p');
    box.id = 'oaf-leaf-skirt-total';
    box.setAttribute('aria-live', 'polite');
  }
  var list = skirts.querySelector('.options-list');
  if (list && box.nextElementSibling !== list) list.parentNode.insertBefore(box, list);
  var leafWord = tally.count === 1 ? ' leaf' : ' leaves';
  var text = tally.total === tally.count ?
    'All ' + tally.count + leafWord + ' assigned.' :
    'Assign a skirt option to each of your ' + tally.count + leafWord + ': ' + tally.total + ' of ' + tally.count + ' assigned.';
  if (box.textContent !== text) box.textContent = text;
  box.classList.toggle('is-complete', tally.total === tally.count);
}
function formatSkirtQuantities() {
  if (!profile || profile.butterflyOnly) return;
  var root = document.getElementById('itoris_dynamicproductoptions');
  var skirts = root && field(root, profile.fields.skirts);
  if (!skirts) return;
  if (!document.getElementById('oaf-leaf-skirt-style')) {
    var style = document.createElement('style');
    style.id = 'oaf-leaf-skirt-style';
    style.textContent = skirtStyleCss;
    document.head.appendChild(style);
  }
  updateSkirtTally(root, skirts);
  skirts.classList.add('oaf-leaf-skirt-options');
  skirts.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
    var row = input.closest('.choice');
    if (row) {
      row.classList.add('oaf-leaf-skirt-choice');
      row.classList.toggle('oaf-leaf-skirt-selected', input.checked);
    }
    var qty = root.querySelector('[id="' + CSS.escape(input.id + '_qty') + '"]');
    if (!qty) return;
    qty.classList.add('oaf-leaf-skirt-qty');
    var choiceLabel = row && row.querySelector('label');
    var treatment = choiceLabel && choiceLabel.querySelector('span');
    qty.setAttribute('aria-label', (treatment ? treatment.textContent.trim() : 'Leaf skirt') + ' quantity');
    var wrapper = qty.closest('.option-qty-wrapper');
    if (wrapper) {
      wrapper.querySelectorAll('.oaf-leaf-skirt-qty-label').forEach(function (label) { label.remove(); });
      var labels = wrapper.querySelectorAll('.option-qty-label');
      labels.forEach(function (label, index) { label.hidden = index > 0; });
    }

  });
}
document.addEventListener('change', formatSkirtQuantities);
document.addEventListener('input', formatSkirtQuantities);
formatSkirtQuantities();
var formatTimerCount = 0;
var formatTimer = setInterval(function () {
  formatSkirtQuantities();
  if (++formatTimerCount >= 60) clearInterval(formatTimer);
}, 500);
document.addEventListener('shopify:section:load', formatSkirtQuantities);
window.addEventListener('dpo_initialized', formatSkirtQuantities);

})();
